(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4799],{

/***/ 86031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60536);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_FooterV2_FooterV2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47327);
/* harmony import */ var components_HeaderV2_HeaderV2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79491);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2962);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils_getLocalizedContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81055);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










var SubCategoryPage = function SubCategoryPage(_ref) {
  var content = _ref.content,
      category = _ref.category,
      subCategory = _ref.subCategory,
      locale = _ref.locale,
      _ref$breadcrumbs = _ref.breadcrumbs,
      breadcrumbs = _ref$breadcrumbs === void 0 ? [] : _ref$breadcrumbs;

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)('knowledgebase'),
      t = _useTranslation.t;

  if (!content) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    children: "Content not found"
  });
  var subCategoryTitle = t('knowledge_base_subcategory_title', {
    subCategory: subCategory,
    category: category
  });
  var subCategoryDescription = t('knowledge_base_subcategory_description', {
    subCategory: subCategory,
    category: category
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "jsx-2205513479" + " " + "page-container",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_HeaderV2_HeaderV2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      locale: locale,
      translations: t
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_4__/* .NextSeo */ .PB, {
      title: "".concat(category, " - ").concat(subCategoryTitle),
      description: subCategoryDescription,
      openGraph: {
        title: subCategoryTitle,
        description: subCategoryDescription
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "jsx-2205513479" + " " + "breadcrumbs",
      children: breadcrumbs.map(function (breadcrumb, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("span", {
          className: "jsx-2205513479",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
            href: breadcrumb.href,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "jsx-2205513479",
              children: breadcrumb.label
            })
          }), index < breadcrumbs.length - 1 && ' / ']
        }, index);
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: "jsx-2205513479" + " " + "subcategory-container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h1", {
        className: "jsx-2205513479",
        children: subCategory
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "jsx-2205513479" + " " + "topics",
        children: Object.keys(content).map(function (topic) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "jsx-2205513479" + " " + "topic",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
              href: "/".concat(locale === 'en' ? 'wbso-knowledge-base' : 'wbso-kennisbank', "/").concat((0,utils_getLocalizedContent__WEBPACK_IMPORTED_MODULE_7__/* .createSlug */ .qi)(category), "/").concat((0,utils_getLocalizedContent__WEBPACK_IMPORTED_MODULE_7__/* .createSlug */ .qi)(subCategory), "/").concat((0,utils_getLocalizedContent__WEBPACK_IMPORTED_MODULE_7__/* .createSlug */ .qi)(topic)),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "jsx-2205513479",
                children: topic
              })
            })
          }, topic);
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_FooterV2_FooterV2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      locale: locale,
      translations: t
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: "2205513479",
      children: [".page-container.jsx-2205513479{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;min-height:150vh;margin-top:120px;}", ".breadcrumbs.jsx-2205513479{margin:20px 0;font-size:14px;text-align:center;}", ".breadcrumbs.jsx-2205513479 a.jsx-2205513479{-webkit-text-decoration:none;text-decoration:none;color:#0070f3;}", ".breadcrumbs.jsx-2205513479 a.jsx-2205513479:hover{-webkit-text-decoration:underline;text-decoration:underline;}", ".subcategory-container.jsx-2205513479{-webkit-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:20px;text-align:center;}", ".subcategory-container.jsx-2205513479 h1.jsx-2205513479{margin-bottom:20px;}", ".topics.jsx-2205513479{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}", ".topic.jsx-2205513479{margin:10px;padding:20px;border:1px solid #ddd;border-radius:4px;-webkit-transition:background-color 0.3s;transition:background-color 0.3s;}", ".topic.jsx-2205513479:hover{background-color:#f0f0f0;}", ".topic.jsx-2205513479 a.jsx-2205513479{-webkit-text-decoration:none;text-decoration:none;color:#0070f3;font-size:18px;}"]
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (SubCategoryPage);

/***/ }),

/***/ 81055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DU": function() { return /* binding */ reverseSlug; },
/* harmony export */   "qi": function() { return /* binding */ createSlug; }
/* harmony export */ });
/* unused harmony export getLocalizedPath */
var createSlug = function createSlug(key) {
  return key.toLowerCase().replace(/ /g, '-').replace(/[?]/g, '');
};
var reverseSlug = function reverseSlug(slug, content) {
  for (var _key in content) {
    if (createSlug(_key) === slug) {
      return _key;
    }
  }

  return null;
};
var getLocalizedPath = function getLocalizedPath(locale, category, subCategory, topic) {
  var basePath = locale === 'en' ? '/wbso-knowledge-base' : '/wbso-kennisbank';

  if (topic) {
    return "".concat(basePath, "/").concat(createSlug(category), "/").concat(createSlug(subCategory), "/").concat(createSlug(topic));
  }

  if (subCategory) {
    return "".concat(basePath, "/").concat(createSlug(category), "/").concat(createSlug(subCategory));
  }

  return "".concat(basePath, "/").concat(createSlug(category));
};

/***/ }),

/***/ 50316:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wbso-knowledge-base/[category]/[subcategory]",
      function () {
        return __webpack_require__(86031);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1522,2962,4577,536,6927,9774,2888,179], function() { return __webpack_exec__(50316); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);